import {Todo} from "./todo";
import {Categorie} from "../../Progetti/Models/Categorie";

export class Check {
  id: number;
  check: string;
  codice: string;
  esito: string;
  valore: number;
  valoreObject: any;
  modifica: boolean;
  categorie: number[];
  categorieSelezionate: Categorie[];
  constructor(modifica: boolean) {
    this.modifica = modifica;
  }
}
